app.filter('MyPositionsFilter', function() {
    return function(items, myPositionsFromCtrl, filterSwitch) {
        var ret = {}
        if (filterSwitch) {
            for (var key in items) {
                if (myPositionsFromCtrl.indexOf(parseInt(key)) != -1) {
                    ret[key] = items[key];
                }
            }
            console.log(ret)
            return ret;
        }
        else {
            return items;
        }

    };

});
